/* -----------------UI--------------- */
import { Pressable } from "react-native";

/* -----------------Icons--------------- */
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type BreadcrumbType = {
	label: string;
	action?: () => void;
};

type Props = {
	breadcrumbs: BreadcrumbType[];
	size?: "small" | "large";
};
export const CustomBreadcrumb = (props: Props) => {
	const { breadcrumbs } = props;
	const theme = useAppTheme();

	return (
		<Box flexDirection="row" alignItems="center" flexWrap="wrap" gap={8}>
			{breadcrumbs.map(({ label, action }, index) => (
				<Pressable
					key={label}
					onPress={() => {
						if (action) {
							action();
						}
					}}
				>
					<Box flexDirection="row" alignItems="center" gap={8}>
						<Text
							variant={props.size === "small" ? "bodyLarge" : "bodyLarge"}
							style={{
								color:
									index !== breadcrumbs.length - 1
										? theme.colors.onSurfaceVariant
										: theme.colors.onPrimaryContainer,
							}}
						>
							{label}
						</Text>

						{index !== breadcrumbs.length - 1 && (
							<Icon
								name="chevron-right"
								size={20}
								color={theme.colors.onSurfaceVariant}
							/>
						)}
					</Box>
				</Pressable>
			))}
		</Box>
	);
};
